/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { CarFromJSON, CarToJSON, } from './';
export function GarageSpotCreateDtoFromJSON(json) {
    return GarageSpotCreateDtoFromJSONTyped(json, false);
}
export function GarageSpotCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'car': !exists(json, 'car') ? undefined : CarFromJSON(json['car']),
        'garageId': !exists(json, 'garageId') ? undefined : json['garageId'],
    };
}
export function GarageSpotCreateDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'car': CarToJSON(value.car),
        'garageId': value.garageId,
    };
}
